import {rolldate} from "./partials/rolldate";
import {slider} from "./partials/slider";
import {autosliders} from "./partials/autosliders";


export function generalQuiz() {
    rolldate();
    slider();

    document.addEventListener('growtypeQuizStart', function (event) {
        slider(event.detail?.quizWrapper || document);
    });

    /**
     * Scroll to bottom
     */
    document.addEventListener('growtypeQuizShowNextQuestion', function (event) {
        const rect = event.detail.nextQuestion.closest('.growtype-quiz')[0].getBoundingClientRect();
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

        if (rect.bottom > viewportHeight - 200) {
            // $(".g-chatform-content").animate({scrollTop: $('.g-chatform-content').prop("scrollHeight")}, 500);
        }
    });

    document.addEventListener('growtypeQuizShowSuccessQuestion', function (event) {
        if ($('.quiz-autosliders') && $('.quiz-autosliders').length > 0) {
            autosliders();
        }
    });
}
